import { ColorPicker, Input, Select } from "antd";
import { LabelFormData } from "components/Forms/LabelsForm/schema.ts";
import { DrawerCollapsible } from "components/UI/DrawerCollapsible/DrawerCollapsible.tsx";
import { DrawerContent } from "components/UI/DrawerContent/DrawerContent.tsx";
import { useGeneralForm } from "components/UI/GeneralForm/hooks/useGeneralForm.ts";
import { CountrySelectSearchable } from "components/UI/Selects/CountrySelectSearchable/CountrySelectSearchable.tsx";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { useController } from "react-hook-form";
import { FormItem } from "react-hook-form-antd";
import { LabelType } from "types/enums.ts";

export const SharedLabelFormContent = () => {
    const { t: tFields } = usePaldockTranslation("forms.general-fields");
    const { control, fieldNames } = useGeneralForm<LabelFormData>();
    const { field: colorField } = useController({ control, name: "color" });

    return (
        <DrawerContent>
            <DrawerCollapsible title={"Settings"}>
                <div className="grid rounded-lg grid-cols-3 gap-x-4 col-span-3">
                    <FormItem control={control} name={fieldNames.name.name} label={tFields("name.label")} required>
                        <Input />
                    </FormItem>
                    <FormItem control={control} name={fieldNames.country_id.name} label={tFields("country.label")}>
                        <CountrySelectSearchable />
                    </FormItem>
                    <FormItem control={control} name={fieldNames.type.name} label={tFields("type.label")}>
                        <Select
                            className={"!h-[31.9px]"}
                            options={[
                                { label: tFields("tag.label"), value: LabelType.Label },
                                { label: tFields("category.label"), value: LabelType.Category },
                            ]}
                        />
                    </FormItem>
                </div>
                <div className="grid rounded-lg grid-cols-3 gap-x-4 col-span-3 mt-4">
                    <div>
                        <label className="text-sm">{tFields("color.label")}</label>
                        <ColorPicker
                            format="hex"
                            disabledAlpha
                            value={colorField.value ?? undefined}
                            onChange={(color) => colorField.onChange(color.toHexString() || null)}
                        />
                    </div>
                </div>
            </DrawerCollapsible>
        </DrawerContent>
    );
};
